// extracted by mini-css-extract-plugin
export default {"about":"styles_about__hAa-f","header":"styles_header__gqREn","text":"styles_text__zOZML"};